import React from 'react';
import { getPageRenderDimensions } from './utils';
import { Dimensions, FlexibleContainerDimensions } from './types';
import { MedicalProfileFiles } from '../../../primary-record-types';
import { Image } from 'react-native';
import Stack from '../../v2BaseComponents/Stack';
import { View } from 'react-native';
import { DirectUrlImageProvider, FullScreenImageView } from '../../v2BaseComponents/FullScreenImageView';
import PressableDynamicOpacity from '../../v2BaseComponents/PressableDynamicOpacity';

export type PageDisplayOwnProps = {
    fileUrl: string;
    containerDimensions: FlexibleContainerDimensions;
    pageDimensions: Dimensions;
    type: 'pdf-image' | 'image';
    rotation: MedicalProfileFiles.Rotation;
    noSkeleton?: boolean;
    identifier?: string;
    isVisible?: boolean;
    enableFocus?: boolean;
};

export type PageDisplayProps = PageDisplayOwnProps;

const PageDisplay: React.FC<PageDisplayProps> = (props) => {
    const pageRenderDimensions = getPageRenderDimensions({
        containerDimensions: props.containerDimensions,
        dimensions: props.pageDimensions,
        rotation: props.rotation,
        fileType: props.type,
    });

    const renderImage = (url: string) => (
        <Image
            source={{ uri: url }}
            alt="Image"
            style={{
                width: pageRenderDimensions.renderDimensions.width,
                height: pageRenderDimensions.renderDimensions.height,
            }}
        />
    );

    const maybeWrapInFocusable = () => {
        if (!props.enableFocus) return renderImage(props.fileUrl);

        return (
            <DirectUrlImageProvider
                image={{
                    imageUrl: props.fileUrl,
                }}
            >
                {(renderImagesData) => {
                    return (
                        <FullScreenImageView
                            renderImagesData={renderImagesData}
                            renderImages={(images, onPress, getIsPressEnabled) => (
                                <PressableDynamicOpacity
                                    onPress={() => onPress(images[0])}
                                    isDisabled={!getIsPressEnabled(images[0])}
                                    style={{
                                        width: pageRenderDimensions.renderDimensions.width,
                                        height: pageRenderDimensions.renderDimensions.height,
                                    }}
                                >
                                    {renderImage(images[0].imageUrl)}
                                </PressableDynamicOpacity>
                            )}
                        />
                    );
                }}
            </DirectUrlImageProvider>
        );
    };

    return (
        <Stack
            horizontal
            style={{
                width: props.containerDimensions.width,
                height: 'height' in props.containerDimensions ? props.containerDimensions.height : undefined,
                display: props.isVisible === false ? 'none' : undefined,
            }}
            testID="image-page-container"
            align={'center'}
            justify={'center'}
        >
            <View
                style={{
                    width: pageRenderDimensions.renderDimensions.width,
                    height: pageRenderDimensions.renderDimensions.height,
                    overflow: 'hidden',
                }}
            >
                {maybeWrapInFocusable()}
            </View>
        </Stack>
    );
};

PageDisplay.displayName = 'PageDisplay';

export default React.memo(PageDisplay);
